export default (tracker) => ({
  async homepageHeroCTAClicked(body) {
    await tracker.track('Homepage Hero CTA Clicked', body)
  },

  async homepagePaginationClicked(body) {
    await tracker.track('Homepage Pagination Clicked', body)
  },
})
